"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 *  This reducer create typical reducer for common type of actions { type, payload } only.
 */
var modalHeader_1 = require("../actions/modalHeader");
function default_1(state, action) {
    if (state === void 0) { state = modalHeader_1.DefaultHeader; }
    switch (true) {
        case action.type.includes(modalHeader_1.SHOW_NAVIGATION): {
            var newState = Object.assign({}, state);
            newState = action.showNavigation;
            return newState;
        }
        default:
            return state;
    }
}
exports.default = default_1;
